<div fxLayout="column"
     fxLayoutGap="1rem"
     class="modal">
    <div fxLayout="row"
         fxLayoutAlign="space-between center">
        <div class="font-size-x-large-container bold-container"
             fxFlex="50"
             fxLayout="row"
             fxLayoutAlign="start">
            Locker Cancellation
        </div>
        <div fxFlex="50"
             fxLayout="row"
             fxLayoutAlign="end">
            <button mat-icon-button
                    mat-dialog-close>
                <mat-icon (click)="close()">close</mat-icon>
            </button>
        </div>
    </div>
    <div>
        <p [innerHTML]="lockerCancellationVerbiageReplaced">
        </p>
    </div>
</div>
